// src/utils/breakpoints.ts

// Enum для строгого определения брейкпоинтов и их порядка
export enum Breakpoint {
  Base = 0,
  Xs = 460,
  Sm = 640,
  Md = 768,
  Md_Plus = 840,
  Lg = 1024,
  Xl = 1280,
  TwoXl = 1536,
}

// Map для удобного получения строковых представлений брейкпоинтов для matchMedia
// Важно: Эти значения должны совпадать с вашими в tailwind.config.js!
export const breakpointPxMap: Record<Exclude<keyof typeof Breakpoint, 'Base'>, string> = {
  Xs: '460px',
  Sm: '640px',
  Md: '768px',
  Md_Plus: '840px',
  Lg: '1024px',
  Xl: '1280px',
  TwoXl: '1536px',
};

/**
 * Определяет текущий активный брейкпоинт на основе ширины окна.
 * Проверяет медиа-запросы, начиная с самого большого.
 * @returns {Breakpoint} Текущий брейкпоинт в виде числового значения.
 */
export const getCurrentBreakpointValue = (): Breakpoint => {
  if (typeof window === 'undefined') {
    return Breakpoint.Base; // Для SSR или среды без DOM
  }

  if (window.matchMedia(`(min-width: ${breakpointPxMap.TwoXl})`).matches) {
    return Breakpoint.TwoXl;
  }
  if (window.matchMedia(`(min-width: ${breakpointPxMap.Xl})`).matches) {
    return Breakpoint.Xl;
  }
  if (window.matchMedia(`(min-width: ${breakpointPxMap.Lg})`).matches) {
    return Breakpoint.Lg;
  }
  if (window.matchMedia(`(min-width: ${breakpointPxMap.Md_Plus})`).matches) {
    return Breakpoint.Md_Plus;
  }
  if (window.matchMedia(`(min-width: ${breakpointPxMap.Md})`).matches) {
    return Breakpoint.Md;
  }
  if (window.matchMedia(`(min-width: ${breakpointPxMap.Sm})`).matches) {
    return Breakpoint.Sm;
  }
  if (window.matchMedia(`(min-width: ${breakpointPxMap.Xs})`).matches) {
    return Breakpoint.Xs;
  }

  return Breakpoint.Base;
};
